import type { Section } from '../shell/sections';

// A section with no screens yet (Discover, Insights, or any section whose flag is off): only its
// name and its description line, in the tab-description style (consistency pass R11, Kristi
// Nov 1). Nothing on screen says what isn't built.

export function SectionPage({ section, wide }: { section: Section; wide: boolean }) {
  return (
    <div class="page section-page">
      {wide ? <h1 class="page-title">{section.name}</h1> : null}
      <p class="queue-description section-description">{section.description}</p>
    </div>
  );
}
